export const MAX_IDLE_TIME = 60; // in minutes
export const IDLE_TIME_INTERVAL = 1000; // in milliseconds
export const TOKEN_REFRESH_INTERVAL = 300000; // (5 minutes) in milliseconds
